import { Directive, inject, TemplateRef, input } from '@angular/core'

@Directive({ selector: '[mcmTemplate]' })
export class TemplateDirective {
  public readonly template: TemplateRef<any> = inject(TemplateRef)
  readonly type = input<string>(undefined, { alias: 'mcmTemplate' })

  getType(): string {
    return this.type()
  }
}
